export const vehiclesConstants = {
  GET_VEHICLE_REQUEST: 'GET_VEHICLE_REQUEST',
  GET_VEHICLE_SUCCESS: 'GET_VEHICLE_SUCCESS',
  GET_VEHICLE_FAILURE: 'GET_VEHICLE_FAILURE',
};
